import {frameworkMobViewPanel} from "../../../core/components/mobViewPanel/configuration/mobViewPanelconfiguration"
import React from "react";


frameworkMobViewPanel.data = {
    "mobPanelButtonsImage": "mobPanelButtonsImage",
}